module.exports = __webpack_public_path__ + "static/media/Ralts_gaussian2.8689cb9e.png";